import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      title: 'Priority Clearance Search',
      subtitle: 'Scope confirmed before work begins',
      description:
        'A basic knockout screening is included with filing. Expanded availability searches and written registrability opinions are separately scoped and quoted; no search guarantees registration.',
    },
    {
      title: 'Filing within 24h',
      subtitle: 'Target: 24 Brazilian business hours',
      description:
        'Our filing target begins after complete approved instructions, required documents, signed Power of Attorney and full cleared advance payment. We then provide the official filing receipt and application number promptly.',
    },
    {
      title: 'Prosecution & Procedural Monitoring',
      subtitle: 'BPTO examination timing varies',
      description:
        'We monitor and report relevant publications through the first-instance decision. Responses to Office Actions, oppositions and appeals require separate approved instructions and fees. Your 12 months of Brazil Trademark Watch run alongside, alerting you to conflicting filings by others.',
    },
    {
      title: 'Grant & Certification',
      subtitle: 'Renewable indefinitely',
      description:
        'Upon approval, we handle the issuance of the Registration Certificate. Your trademark is valid for 10 years from the grant date and can be renewed indefinitely. Brazil Trademark Watch can continue at US$ 150 per mark per year.',
    },
  ];

  return (
    <section id="process" className="py-20 bg-white scroll-mt-24 relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-4">
          Process
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="bg-background-auxiliary rounded-2xl p-8 shadow-sm hover:shadow-md border border-gray-100/50">
              <div className="flex items-center justify-center w-14 h-14 bg-primary text-white rounded-full text-xl font-bold mb-6 shadow-md">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-text mb-3">
                {step.title}
              </h3>
              <p className="text-primary font-semibold mb-4 text-lg">
                {step.subtitle}
              </p>
              <p className="text-text/70 leading-relaxed text-base">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
